import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import CountUp from 'react-countup'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import { fontWeight } from 'themes/font'
import TrackVisibility from 'react-on-screen'
import numeral from 'numeral'

const Section = styled.section`
  background: url('/img/home-page/statictis/bg.svg') top;
  background-size: cover;
  padding-top: 64px;
  padding-bottom: 48px;
  margin-top: 32px;
  h1 {
    font-size: 32px;
    margin-bottom: 16px;
    font-weight: ${fontWeight.bold} !important;
  }
  ${media.md`
    h1 {
      text-align: center;
      margin-bottom: 32px;
      color: #333;
    }
  `}
`

const List = styled(Row)``

const Item = styled(Col)`
  text-align: center;
  padding: 16px 0;
  img {
    height: 120px;
  }
  h2 {
    font-weight: ${fontWeight.normal};
    margin-top: 16px;
    margin-bottom: 8px;
    font-size: 1.25rem;
  }
  p {
    font-size: 1rem;
    margin-bottom: 0;
    color: #0066FF
  }
  ${media.md`
    h2 {
      font-size: 2rem;
    }
  `}
`

export default class Statistic extends Component {
  handleFormatting = (value) => {
    return numeral(value).format('0,0')
  }

  render () {
    const { heading, items } = this.props.data
    return (
      <Section>
        <Container>
          <h1 className='wow fadeIn'>{heading}</h1>
          <TrackVisibility once>
            {({ isVisible }) => (
              <List>
                {items.map((item, index) => (
                  <Item key={index} xs={6} md={3} className='wow fadeIn'>
                    <img src={item.icon.publicURL} alt={item.value} />
                    <h2>
                      <CountUp
                        end={isVisible ? parseInt(item.value) : 0}
                        formattingFn={this.handleFormatting}
                      />
                    </h2>
                    <p>{item.label}</p>
                  </Item>
                ))}
              </List>
            )}
          </TrackVisibility>
        </Container>
      </Section>
    )
  }
}
